// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1mnkN","top":"styles_top__hWwCa","left":"styles_left__3jQa7","description":"styles_description__7u4q0"};